import type React from 'react'
import type { IconProps } from './types'

const MessageIcon: React.FC<IconProps> = ({ size = 20, className = '', ...props }) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={size}
		height={size}
		viewBox='0 0 24 24'
		fill='none'
		stroke='currentColor'
		strokeWidth='2'
		strokeLinecap='round'
		strokeLinejoin='round'
		className={`lucide lucide-message-square-text-icon lucide-message-square-text ${className}`}
		{...props}
		aria-hidden='true'>
		<path d='M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z' />
		<path d='M7 11h10' />
		<path d='M7 15h6' />
		<path d='M7 7h8' />
	</svg>
)

export default MessageIcon
